import { render, staticRenderFns } from "./EditAccount.vue?vue&type=template&id=008e6aef&scoped=true"
import script from "./EditAccount.vue?vue&type=script&lang=js"
export * from "./EditAccount.vue?vue&type=script&lang=js"
import style0 from "./EditAccount.vue?vue&type=style&index=0&id=008e6aef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008e6aef",
  null
  
)

export default component.exports